module.exports = require('./helpers/bundle-url').getBundleURL('8De2n') + "logo.c51670a8.svg";